// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__tjxpC","spin":"Loader_spin__MGTqx","loader2":"Loader_loader2__fYL4W","image":"Loader_image__ijVDA"};